import { render, staticRenderFns } from "./EmailReminder.vue?vue&type=template&id=bc18a108&"
import script from "./EmailReminder.vue?vue&type=script&lang=ts&"
export * from "./EmailReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports